import Auth, { CognitoUser } from '@aws-amplify/auth'
import { CognitoUserAttribute } from 'amazon-cognito-identity-js'
import { handleError } from '../../utilities'
import { renderAllData } from '../../utilities/graphql'
import { FavouriteDeal } from './types'

export function getAttributeByName(name: string, attributes: CognitoUserAttribute[]) {
    const attribute = attributes.find(attribute => attribute.getName() === name)

    return attribute ? attribute.getValue() : ''
}

export async function prepareUser() {
    const user = await Auth.currentAuthenticatedUser()

    if (!user || !(user as CognitoUser).getUserAttributes) {
        handleError('Having issue finding the user!')
    }

    return user
}

export async function getUserUsername(user: CognitoUser) {
    const attributes = await new Promise<CognitoUserAttribute[]>((resolve, reject) => {
        (user as CognitoUser).getUserAttributes((err, attributes) => {
            if (err) {
                reject(err)
                return
            }

            resolve(attributes)
        })
    })

    return getAttributeByName('sub', attributes)
}

export async function getUserAttribute(user: CognitoUser, attribute: string) {
    const attributes = await new Promise<CognitoUserAttribute[]>((resolve, reject) => {
        (user as CognitoUser).getUserAttributes((err, attributes) => {
            if (err) {
                reject(err)
                return
            }

            resolve(attributes)
        })
    })

    return getAttributeByName(attribute, attributes)
}

export async function getFavDealsForUser(username: string) {
    const params = {
        userId: { eq: username },
    }

    const favDeals: FavouriteDeal[] = await renderAllData([], undefined, 'listUserFavouriteDeals', params)

    return favDeals
}
